import { Alert, IconButton, Tooltip } from '@mui/material'
import { IoTrashOutline } from 'react-icons/io5'

import { useRemoveQuestionMutation } from '@/services/api'
import type { Question } from '@/types'

import { ConfirmButton } from '..'

interface QuestionDeleteProps {
  isMobile: boolean
  question: Question
}

function QuestionDelete({ question, isMobile }: QuestionDeleteProps) {
  const [trigger, { isLoading, isSuccess }] = useRemoveQuestionMutation()

  const onDelete = async () => {
    await trigger(question.id)
  }

  return (
    <ConfirmButton
      loading={isLoading}
      success={isSuccess}
      onConfirm={onDelete}
      variant="destructive"
      title="Excluir questão"
      successMessage="A questão foi removida com sucesso!"
      body={
        <Alert variant="outlined" severity="warning">
          Remover uma questão é irreversível. Lembre-se: só é possível remover uma questão
          que ainda não está sendo usada em uma avaliação!
        </Alert>
      }
      trigger={
        <Tooltip title="Excluir questão" arrow placement={isMobile ? 'bottom' : 'top'}>
          <IconButton
            size={isMobile ? 'small' : 'medium'}
            sx={{
              width: isMobile ? 32 : 40,
              height: isMobile ? 32 : 40,
              backgroundColor: ({ palette }) => palette.error.main + '15',
              color: ({ palette }) => palette.error.main,
              border: ({ palette }) => `1px solid ${palette.error.main}20`,
              boxShadow: ({ shadows }) => shadows[1],
              '&:hover': {
                backgroundColor: ({ palette }) => palette.error.main + '25',
                boxShadow: ({ shadows }) => shadows[3],
                transform: 'translateY(-1px)',
                border: ({ palette }) => `1px solid ${palette.error.main}40`,
              },
              '&:active': {
                transform: 'translateY(0)',
                boxShadow: ({ shadows }) => shadows[1],
              },
              transition: ({ transitions }) =>
                transitions.create(
                  ['background-color', 'box-shadow', 'transform', 'border'],
                  {
                    duration: transitions.duration.short,
                  },
                ),
            }}>
            <IoTrashOutline size={isMobile ? 16 : 18} />
          </IconButton>
        </Tooltip>
      }
    />
  )
}

export default QuestionDelete
